// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"0f09d862","238":"36b8c3a0","412":"104fc52a","496":"859c67f7","526":"2a7d370c","678":"e4526a6a","717":"b0851f1e","856":"fde64a52","946":"bea9298d"}[chunkId] + ".chunk.js";
};